import React, { useState, useEffect, useContext } from 'react';
import { HiOutlinePlusCircle, HiOutlineMinusCircle } from "react-icons/hi"
import axios from "axios";
import { faqLogApi, faqTrendTopics } from '../../Config/config';
import { UserContext } from '../../Contexts/UserContext';
import Loader from '../../Components/Loader';
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
} from "@material-tailwind/react";
import { RaiseRequestContext } from '../../Contexts/RaiseRequestContext'
import { FaqContext } from '../../Contexts/FaqContext';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { ChevronDown, ChevronUp } from 'lucide-react';

function PE(props) {
  const { getToken } = useContext(UserContext);
  const { openRequestPopup } = useContext(RaiseRequestContext)
  const { selectedSearchResult, setSelectedSearchResult, isLoading, faqs, setIsLoading, setTrends } = useContext(FaqContext)
  
  // State for image lightbox
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [lightboxImages, setLightboxImages] = useState([]);
  
  // State for custom sections
  const [openSections, setOpenSections] = useState({});
  
  const toggleSection = (id) => {
    if (!openSections[id]) {
      createLog(id)
      // Close all other sections and open only the clicked one
      setOpenSections({ [id]: true });
      // Scroll to the specific section when opening
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    } else {
      // If already open, close it
      setOpenSections({});
    }
    setSelectedSearchResult(openSections[id] ? null : id);
  };

  const handleOpen = (faq_id, isfrom) => {
    if (selectedSearchResult != faq_id) {
      createLog(faq_id)
    }
    setSelectedSearchResult(selectedSearchResult == faq_id ? null : faq_id)
  };

  const searchTrend = () => {
    axios(`${faqTrendTopics}`, {
      method: "POST",
      data: {
        "db_type": 'PE'
      },
      headers: {
        "Content-Type": "application/json",
        "Authorization": getToken()
      },
    })
      .then((response) => {
        if (response.data.success == true) {
          setTrends(response.data.data ?? [])
          setIsLoading(false)
        }
      })
      .catch((error) => {
        console.log("API not working - faq trend ", error);
      });
  }

  const createLog = (faq_id) => {
    axios(`${faqLogApi}`, {
      method: "POST",
      data: {
        "faq_id": faq_id,
        "db_type": "PE"
      },
      headers: {
        "Content-Type": "application/json",
        "Authorization": getToken()
      },
    })
      .then((response) => {
        searchTrend()
      })
      .catch((error) => {
        console.log("API not working - faq log", error);
      });
  }

  useEffect(() => {
    console.log(selectedSearchResult, 'selectedSearchResult');
  }, [faqs])

  const Section = ({ id, title, className, children }) => (
      <div className={`${className}`}>
        <button onClick={() => toggleSection(id)} className="px-4 font-medium text-left w-full flex justify-between items-center text-gray-400 border-b-0 h-[55px]">
          <span className="font-sans_medium_body text-[#333333] font-SequelSans text-[15pt] leading-[18pt] tracking-[-0.32pt] lg:tracking-[-0.39px] lg:leading-[22px] lg:text-[16px]">
            {title}
          </span>
          {openSections[id] ? (
            <HiOutlineMinusCircle className="h-5 w-5 text-[#F1CA75]" aria-hidden="true" />
          ) : (
            <HiOutlinePlusCircle className="h-5 w-5 text-[#F1CA75]" aria-hidden="true" />
          )}
        </button>
        {openSections[id] && <div className="pr-8 py-0 overflow-visible h-auto">{children}</div>}
      </div>
    )

  return (
    <div>
      <style dangerouslySetInnerHTML={{__html: `
        .faq-section .accordion-custom {
          height: auto !important;
          overflow: visible !important;
        }
        .accordion-custom [role="region"] {
          height: auto !important;
          max-height: none !important;
          overflow: visible !important;
        }
      `}} />
      
      {/* Image Lightbox */}
      {isLightboxOpen && (
        <Lightbox
          mainSrc={lightboxImages[currentImageIndex]}
          nextSrc={lightboxImages[(currentImageIndex + 1) % lightboxImages.length]}
          prevSrc={lightboxImages[(currentImageIndex + lightboxImages.length - 1) % lightboxImages.length]}
          onCloseRequest={() => setIsLightboxOpen(false)}
          onMovePrevRequest={() => 
            setCurrentImageIndex((currentImageIndex + lightboxImages.length - 1) % lightboxImages.length)
          }
          onMoveNextRequest={() => 
            setCurrentImageIndex((currentImageIndex + 1) % lightboxImages.length)
          }
          imageTitle={`Image ${currentImageIndex + 1} of ${lightboxImages.length}`}
        />
      )}
      <div className="bg-white">
        <div className="max-w-7xl mx-auto py-1 px-4 sm:py-6 sm:px-6 lg:px-8">
          <div className="max-w-[930px] mx-auto space-y-2 divide-y-2 divide-gray-200">
            <div className="mt-6 font-sans_medium_body text-center text-[#333333] text-[16pt] leading-[19pt] tracking-[-0.34pt] lg:text-[20px] lg:text-[#333333] lg:leading-[24px] lg:tracking-[-0.43px] lg:mt-1 mb-4">
              Frequently Asked Questions - PE-VC Database
            </div>
            <dl className="mt-6 divide-y-2 divide-gray-200">
              {
                isLoading ? (
                  <center className="mt-4"><Loader /></center>
                ) : (!isLoading && faqs.length <= 0) ? (
                  <center className="mt-4 font-sans_medium_body lg:text-[15px] text-[15px] text-[#333333]">No Data Found</center>
                ) : (
                  faqs.map((key) => {
                    // Replace URLs in answer with "click here"
                    const urlRegex = /(https?:\/\/[^\s]+)/g;
                    let modifiedAnswer = key.answer;
                    const urls = key.answer.match(urlRegex);

                    if (urls && urls.length > 0) {
                      urls.forEach((url) => {
                        modifiedAnswer = modifiedAnswer.replace(
                          url,
                          `<a href="${url}" target="_blank" rel="noopener noreferrer" class="text-[#BC8B20] cursor-pointer">click here</a>`
                        );
                      });
                    }

                    return (
                      <section id={key.id} className='' key={key.id}>
                        <Section
                          id={key.id}
                          title={key.question}
                          className="focus:border-none outline-none accordion-custom"
                        >
                            {/* Modified answer with clickable links */}
                            <p
                              className="lg:px-4 font-sans_book_body text-[14pt] leading-[17pt] tracking-[-0.3pt] lg:text-[#333333] lg:text-[16px] lg:tracking-[-0.34px] lg:leading-6"
                              dangerouslySetInnerHTML={{ __html: modifiedAnswer }}
                            />

                            {/* Handle array of URLs */}
                            {key.urls && key.urls.length > 0 && (
                              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4 mb-8">
                                {key.urls.map((url, index) => (
                                  <div key={index} className='flex justify-center'>
                                    {key.assert_type === "image" ? (
                                      <img 
                                        src={url} 
                                        alt={`${key.question} - image ${index+1}`} 
                                        className="max-w-full rounded cursor-pointer hover:opacity-90 transition-opacity" 
                                        style={{ height: 220, maxWidth: '100%' }} 
                                        onClick={() => {
                                          setLightboxImages(key.urls);
                                          setCurrentImageIndex(index);
                                          setIsLightboxOpen(true);
                                        }}
                                      />
                                    ) : key.assert_type === "video" ? (
                                      <video width="320" className="faqvideo" controls style={{ height: 220 }}>
                                        <source className="video-link" src={url} type="video/mp4" />
                                        Your browser does not support the video tag.
                                      </video>
                                    ) : key.assert_type === "html_embeddings" ? (
                                      <div className="w-full max-w-4xl">
                                        <iframe
                                          src={url}
                                          width="100%"
                                          height="600"
                                          frameBorder="0"
                                          allowFullScreen
                                          className="rounded border border-gray-300 min-h-[400px]"
                                          title={`${key.question} - embed ${index+1}`}
                                          style={{ minHeight: '400px', height: 'auto' }}
                                        />
                                      </div>
                                    ) : (
                                      <video width="320" className="faqvideo" controls style={{ height: 220 }}>
                                        <source className="video-link" src={url} type="video/mp4" />
                                        Your browser does not support the video tag.
                                      </video>
                                    )}
                                  </div>
                                ))}
                              </div>
                            )}

                            {/* Handle HTML embeddings */}
                            {key.html_embeddings && (
                              <div className="flex justify-center mt-4 mb-8">
                                <div 
                                  className="w-full "
                                  dangerouslySetInnerHTML={{ __html: key.html_embeddings }}
                                />
                              </div>
                            )}
                        </Section>
                      </section>
                    )
                  })
                )
              }
            </dl>
          </div>
          <p className={`${faqs.length == 0 ? 'border-none' : 'border-b-[1px] border-[#D3D3D3]'} md:mx-[100px]`}></p>
          <div className="md:flex justify-center mt-9 mb-4">
            <p className="text-[#2B2A29] text-center text-[18px] tracking-[-0.39px] leading-[22px] font-sans_semi_bold px-1">
              Still have questions?
            </p>
            <p className='hidden md:flex text-center justify-center font-sans_book_body'>
              Please
              <a
                className="text-[#BC8B20] text-[18px] font-sans_book_body tracking-[-0.39px] leading-[22px] px-1 cursor-pointer"
                onClick={() => openRequestPopup("faq")}
              >
                click here
              </a>
              to interact with our team.
            </p>
            <div className='block md:hidden'>
              <p className='flex text-center justify-center font-sans_book_body md:hidden'>
                Please
                <a
                  className="text-[#BC8B20] text-[18px] font-sans_book_body tracking-[-0.39px] leading-[22px] px-1 cursor-pointer"
                  onClick={() => openRequestPopup("faq")}
                >
                  click here
                </a>
              </p>
              <p className='flex justify-center'>
                to interact with our team.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PE
